module.exports = __webpack_public_path__ + "static/media/star-empty.4c2bc901.svg";